import { render, staticRenderFns } from "./DemoPage.vue?vue&type=template&id=596fd298&scoped=true&"
import script from "./DemoPage.vue?vue&type=script&lang=ts&"
export * from "./DemoPage.vue?vue&type=script&lang=ts&"
import style0 from "./DemoPage.vue?vue&type=style&index=0&id=596fd298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596fd298",
  null
  
)

export default component.exports